export const ROLES = {
  sAdmin: 100,
  admin: 80,
  serviceTechnical: 20,
  user: 0,
} as const;

export type Role = keyof typeof ROLES;